import TargetPositions from './TargetPositions.page';

export default TargetPositions;